import { StorageService } from '../services';

const isSessionExpired = () => {
  const loginTimeStr = StorageService.loginTime.getValue();
  const loginTime = Number(loginTimeStr); // Convert string to number

  if (!loginTime || isNaN(loginTime)) return true;

  const now = Date.now();
  const sessionDuration = 60 * 60 * 1000; // 1 hour in ms

  return now - loginTime > sessionDuration;
};

export default isSessionExpired;
